import styled from 'styled-components';
import Section from 'components/Section';
import { colors } from 'stylesheets';

export const SectionStyled = styled(Section)`
  flex-wrap: wrap !important;
  align-items: start !important;
`;

export const Container = styled.div`
  width: 90%;
  min-height: 500px;
  display: flex;
  justify-content: space-between;
  > div {
    &:first-child {
      width: 65%;
    }

    &:last-child {
      width: 30%;
    }
  }
`;

export const Header = styled.div`
  margin: 30px auto 30px auto;
  height: 50px !important;
  flex-basis: 90%;
  align-self: center;
  button {
    height: 50px;
    &:not(:first-child) {
      margin-left: 20px;
    }
    img {
      width: 20px;
      height: 20px;
    }
    span {
      font-size: 12px;
    }
  }
`;
